import React, { useState } from 'react';
import { useApp } from '../context/AppContext';
import { t } from '../data/translations';
import { CAT_META, PLAN_LIMITS } from '../data/initialState';

const getCats = (lang) => [
  { name: lang==='en'?'Food':lang==='sv'?'Mat':lang==='da'?'Mad':'Mat', icon:'🍕', color:'#FF6B6B', bg:'#FFF0F0' },
  { name: 'Transport', icon:'🚗', color:'#4ECDC4', bg:'#F0FFFE' },
  { name: 'Shopping', icon:'🛍️', color:'#A78BFA', bg:'#F5F3FF' },
  { name: lang==='en'?'Entertainment':lang==='sv'?'Underhållning':lang==='da'?'Underholdning':'Underholdning', icon:'🎬', color:'#F59E0B', bg:'#FFFBEB' },
  { name: lang==='en'?'Clothing':lang==='sv'?'Kläder':lang==='da'?'Tøj':'Klær', icon:'👕', color:'#EC4899', bg:'#FDF2F8' },
  { name: lang==='en'?'Health':lang==='sv'?'Hälsa':lang==='da'?'Sundhed':'Helse', icon:'💊', color:'#10B981', bg:'#ECFDF5' },
  { name: lang==='en'?'Café & food':lang==='sv'?'Café & mat':lang==='da'?'Café & mad':'Kafé & mat', icon:'☕', color:'#8B5CF6', bg:'#F5F3FF' },
  { name: lang==='en'?'Savings':lang==='sv'?'Sparande':lang==='da'?'Opsparing':'Sparing', icon:'🪙', color:'#22C97A', bg:'#F0FFF4' },
  { name: lang==='en'?'Other':lang==='sv'?'Annat':lang==='da'?'Andet':lang==='en'?'Other':lang==='sv'?'Annat':lang==='da'?'Andet':'Annet', icon:'💸', color:'#6B7280', bg:'#F9FAFB' },
];

const getCurrency = (lang) => lang==='en'?'$':lang==='da'?'kr (DKK)':lang==='sv'?'kr (SEK)':'kr';
const fmt = (n, lang) => {
  const locale = lang==='en'?'en-US':lang==='sv'?'sv-SE':lang==='da'?'da-DK':'nb-NO';
  const num = Math.round(Math.abs(n)).toLocaleString(locale);
  if (lang==='en') return '$' + num;
  if (lang==='sv') return num + ' kr';
  if (lang==='da') return num + ' kr';
  return num + ' kr';
};


function UpsellBanner({ title, desc, plan, label, dispatch }) {
  return (
    <div style={{ background:'#F5F3FF', border:'1.5px solid #DDD6FE', borderRadius:'var(--r-lg)', padding:'1.25rem', textAlign:'center', margin:'1rem 0' }}>
      <div style={{ fontSize:32, marginBottom:8 }}>🔒</div>
      <div style={{ fontFamily:'var(--font-display)', fontSize:15, fontWeight:700, color:'#5B21B6', marginBottom:6 }}>{title}</div>
      <div style={{ fontSize:13, color:'#6D28D9', marginBottom:12, lineHeight:1.5 }}>{desc}</div>
      <button onClick={() => dispatch({ type:'SET_PLAN', payload: plan })} style={{ padding:'10px 20px', background: plan==='premium' ? '#7C3AED':'#4F46E5', color:'white', border:'none', borderRadius:'var(--r-full)', fontSize:13, fontWeight:700, cursor:'pointer' }}>
        {label}
      </button>
    </div>
  );
}

export default function TabBudsjett({ onNav, syncTransaction, syncGoal, syncSubscription }) {
  const { state, dispatch } = useApp();

  // First visit tip via Savvy
  React.useEffect(() => {
    const visited = localStorage.getItem('savely_visited_budsjett');
    if (!visited) {
      localStorage.setItem('savely_visited_budsjett', '1');
    }
  }, []);
  const lang = state.language || 'en';
  const [desc, setDesc] = useState('');
  const [amount, setAmount] = useState('');
  const [cat, setCat] = useState('Mat');
  const [showImpulse, setShowImpulse] = useState(false);
  const [impulseItem, setImpulseItem] = useState('');
  const [impulseAmt, setImpulseAmt] = useState('');
  const [impulseSaved, setImpulseSaved] = useState(false);
  const [showLock, setShowLock] = useState(false);
  const [lockActive, setLockActive] = useState(false);
  const [lockThreshold, setLockThreshold] = useState('500');
  const [view, setView] = useState('list');
  const [search, setSearch] = useState('');
  const [budTab, setBudTab] = useState('list');
  const [newSubName, setNewSubName] = useState('');
  const [newSubAmt, setNewSubAmt] = useState('');
  const [newSubCat, setNewSubCat] = useState(lang==='en'?'Streaming':lang==='sv'?'Streaming':lang==='da'?'Streaming':'Strømming');

  const limits = PLAN_LIMITS[state.plan] || PLAN_LIMITS.free;
  const spentCat = lang==='en'?'Savings':lang==='sv'?'Sparande':lang==='da'?'Opsparing':'Sparing';
  const spent = (state.transactions || []).filter(t => t.amount < 0 && !t.locked && t.cat !== spentCat).reduce((s,t) => s + Math.abs(t.amount), 0);
  const saved = (state.transactions || []).filter(t => t.cat === spentCat || (t.amount > 0 && !t.locked)).reduce((s,t) => s + Math.abs(t.amount), 0);
  const income = state.income || 0;
  const expenses = state.expenses || 0;
  // inntekt - faste utgifter - brukt (ikke-låst) - spart = til bruk
  const left = Math.max(0, income - expenses - spent);



  const addTx = () => {
    if (!desc.trim() || !amount) return;
    const amt = Math.abs(parseFloat(amount));
    if (lockActive && limits.hasLock && amt > parseFloat(lockThreshold)) {
      alert(lang==='en'?`⛔ Purchase lock active! Purchases over $${lockThreshold} are blocked.`:lang==='sv'?`⛔ Köpslås aktivt! Köp över ${lockThreshold} kr blockeras.`:lang==='da'?`⛔ Køblås aktiv! Køb over ${lockThreshold} kr er blokeret.`:`⛔ Kjøpslås aktiv! Kjøp over ${lockThreshold} kr er blokkert.`);
      return;
    }
    const newTx = { id: Date.now(), desc: desc.trim(), cat, amount: -amt, date: lang==='en'?'Today':lang==='sv'?'Idag':lang==='da'?'I dag':'I dag', time: new Date().toTimeString().slice(0,5) };
    dispatch({ type:'ADD_TRANSACTION', payload: newTx });
    if (syncTransaction) syncTransaction(newTx, 'add');
    setDesc(''); setAmount('');
  };

  const addSub = () => {
    if (!newSubName || !newSubAmt) return;
    const sub = { 
      id:Date.now(), name:newSubName, amount:parseFloat(newSubAmt), cat:newSubCat,
      nextCharge: newSubDay ? (() => {
        const d = new Date(); const day = parseInt(newSubDay);
        if (d.getDate() >= day) d.setMonth(d.getMonth()+1);
        d.setDate(day); return d.toISOString().split('T')[0];
      })() : null
    };
    dispatch({ type:'ADD_SUBSCRIPTION', payload: sub });
    if (syncSubscription) syncSubscription(sub, 'add');
    setNewSubName(''); setNewSubAmt('');
  };

  const filteredTx = (state.transactions || []).filter(tx =>
    tx.desc.toLowerCase().includes(search.toLowerCase()) ||
    tx.cat.toLowerCase().includes(search.toLowerCase())
  );

  const catBreakdown = getCats(lang).map(c => ({
    cat:c.name, total: (state.transactions || []).filter(t=>t.cat===c.name&&t.amount<0&&!t.locked).reduce((s,t)=>s+Math.abs(t.amount),0)
  })).filter(c=>c.total>0).sort((a,b)=>b.total-a.total);

  const topDay = Object.entries(
    (state.transactions || []).filter(t=>t.amount<0&&!t.locked).reduce((acc,t) => { acc[t.date]=(acc[t.date]||0)+Math.abs(t.amount); return acc; }, {})
  ).sort((a,b)=>b[1]-a[1])[0];

  const topCat = catBreakdown[0];
  const totalSubs = (state.subscriptions || []).reduce((s,a)=>s+a.amount, 0);

  const tabs = [
    { id:'list', label:lang==='en'?'Transactions':lang==='sv'?'Transaktioner':lang==='da'?'Transaktioner':'Transaksjoner', locked:false },
    { id:'stats', label:lang==='en'?'Analysis':lang==='sv'?'Analys':lang==='da'?'Analyse':'Analyse', locked:!limits.hasAnalysis },
    { id:'subscriptions', label:lang==='en'?'Subscriptions':lang==='sv'?'Prenumerationer':lang==='da'?'Abonnementer':'Abonnement', locked:!limits.hasSubscriptions },
  ];

  return (
    <div style={{ padding:'1.25rem 1rem' }}>


      {/* Header + kjøpslås knapp */}
      <div className="fade-up" style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'1rem' }}>
        <div style={{ fontFamily:'var(--font-display)', fontSize:22, fontWeight:800, color:'var(--ink)' }}>{t(lang,'budget')}</div>
        {limits.hasLock && (
          <button onClick={() => setShowLock(!showLock)} style={{
            padding:'7px 14px', fontSize:12, fontWeight:700, cursor:'pointer', border:'none', borderRadius:'var(--r-full)',
            background: lockActive ? 'var(--r400)' : 'var(--surface)',
            color: lockActive ? 'white' : 'var(--ink3)',
          }}>
            {lockActive ? (lang==='en'?'🔒 Lock ON':lang==='sv'?'🔒 Lås PÅ':lang==='da'?'🔒 Lås TIL':'🔒 Kjøpslås PÅ') : (lang==='en'?'🔓 Purchase lock':lang==='sv'?'🔓 Köpslås':lang==='da'?'🔓 Købslås':'🔓 Kjøpslås')}
          </button>
        )}
      </div>

      {/* Kjøpslås innstillinger */}
      {showLock && limits.hasLock && (
        <div className="fade-up" style={{ background:'var(--r50)', border:'1.5px solid var(--r100)', borderRadius:'var(--r-lg)', padding:'1rem', marginBottom:'1rem' }}>
          <div style={{ fontFamily:'var(--font-display)', fontSize:14, fontWeight:700, color:'var(--r600)', marginBottom:6 }}>{lang==='en'?'🔒 Purchase lock':lang==='sv'?'🔒 Köpslås':lang==='da'?'🔒 Køblås':'🔒 Kjøpslås'}</div>
          <div style={{ fontSize:13, color:'var(--r400)', marginBottom:10 }}>{lang==='en'?'Block all purchases above a limit.':lang==='sv'?'Blockera alla köp över en gräns.':lang==='da'?'Bloker alle køb over en grænse.':'Blokker alle kjøp over en bestemt grense.'}</div>
          <div style={{ marginBottom:10 }}>
            <label style={{ fontSize:12, color:'var(--ink3)', display:'block', marginBottom:4 }}>{lang==='en'?'Block purchases over ($)':lang==='sv'?'Blockera köp över (kr)':lang==='da'?'Bloker køb over (kr)':'Blokker kjøp over (kr)'}</label>
            <input type="number" value={lockThreshold} onChange={e=>setLockThreshold(e.target.value)} style={{ fontSize:14 }}/>
          </div>
          <button onClick={() => { setLockActive(!lockActive); setShowLock(false); }} style={{ width:'100%', padding:11, background: lockActive ? 'var(--surface)' : 'var(--r400)', color: lockActive ? 'var(--ink)' : 'white', border:'none', borderRadius:'var(--r-md)', fontSize:14, fontWeight:700, cursor:'pointer' }}>
            {lockActive ? lang==='en'?'Turn off lock':lang==='sv'?'Stäng av lås':lang==='da'?'Sluk lås':'Slå av kjøpslås' : lang==='en'?'Turn on lock 🔒':lang==='sv'?'Slå på lås 🔒':lang==='da'?'Slå lås til 🔒':'Slå på kjøpslås 🔒'}
          </button>
        </div>
      )}

      {/* Statistikk-kort */}
      <div className="fade-up-1" style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr 1fr', gap:6, marginBottom:'1rem' }}>
        {[
          [lang==='en'?'Income':lang==='sv'?'Inkomst':lang==='da'?'Indkomst':'Inntekt', fmt(income, lang), 'var(--g600)'],
          [lang==='en'?'Spent':lang==='sv'?'Spenderat':lang==='da'?'Brugt':'Brukt', fmt(spent, lang), 'var(--r400)'],
          [lang==='en'?'Saved':lang==='sv'?'Sparat':lang==='da'?'Sparet':'Spart', fmt(saved, lang), '#7C3AED'],
          [lang==='en'?'Available':lang==='sv'?'Tillgängligt':lang==='da'?'Tilgængeligt':'Til bruk', fmt(left, lang), left < income*0.1 ? 'var(--r400)' : 'var(--g400)'],
        ].map(([l,v,c]) => (
          <div key={l} style={{ background:'var(--card)', border:'1px solid var(--border)', borderRadius:'var(--r-lg)', padding:'0.75rem', textAlign:'center' }}>
            <div style={{ fontSize:9, color:'var(--ink3)', fontWeight:600, textTransform:'uppercase', letterSpacing:0.5, marginBottom:3 }}>{l}</div>
            <div style={{ fontFamily:'var(--font-display)', fontSize:13, fontWeight:800, color:c }}>{v}</div>
          </div>
        ))}
      </div>


      {/* Tabs */}
      <div style={{ display:'flex', gap:6, marginBottom:12, marginTop:4 }}>
        {[['list', lang==='en'?'Transactions':lang==='sv'?'Transaktioner':lang==='da'?'Transaktioner':'Transaksjoner'],
          ['subs', lang==='en'?'Subscriptions':lang==='sv'?'Prenumerationer':lang==='da'?'Abonnementer':'Abonnementer'],
        ].map(([id,label]) => (
          <button key={id} onClick={() => setBudTab(id)} style={{
            padding:'7px 16px', borderRadius:'var(--r-full)', fontSize:12, fontWeight:700,
            border: budTab===id ? 'none' : '1px solid var(--border)',
            background: budTab===id ? 'var(--ink)' : 'var(--surface)',
            color: budTab===id ? 'var(--paper)' : 'var(--ink3)', cursor:'pointer',
          }}>{label}</button>
        ))}
      </div>

      {budTab === 'list' && (
        <div>
          <input value={search} onChange={e=>setSearch(e.target.value)}
            placeholder={lang==='en'?'Search...':lang==='sv'?'Sök...':lang==='da'?'Søg...':'Søk...'}
            style={{ width:'100%', marginBottom:10, fontSize:13 }}/>

          {/* Add form - beautiful */}
          <div style={{ background:'var(--card)', border:'1.5px solid var(--border)', borderRadius:'var(--r-lg)', padding:'1rem', marginBottom:12 }}>
            <div style={{ fontSize:12, fontWeight:700, color:'var(--ink3)', marginBottom:10, textTransform:'uppercase', letterSpacing:1 }}>
              + {lang==='en'?'New transaction':lang==='sv'?'Ny transaktion':lang==='da'?'Ny transaktion':'Ny transaksjon'}
            </div>
            {/* Category picker - visual */}
            <div style={{ display:'flex', gap:6, flexWrap:'wrap', marginBottom:10 }}>
              {getCats(lang).map(c => (
                <button key={c.name} onClick={() => setCat(c.name)} style={{
                  padding:'6px 10px', borderRadius:'var(--r-full)', fontSize:12, fontWeight:600,
                  border: cat===c.name ? `2px solid ${c.color}` : '1px solid var(--border)',
                  background: cat===c.name ? c.bg : 'var(--surface)',
                  color: cat===c.name ? c.color : 'var(--ink3)',
                  cursor:'pointer', display:'flex', alignItems:'center', gap:4,
                  transition:'all 0.15s',
                }}>
                  {c.icon} {c.name}
                </button>
              ))}
            </div>
            <div style={{ display:'flex', gap:8, marginBottom:8 }}>
              <input type="text" value={desc} onChange={e=>setDesc(e.target.value)}
                placeholder={lang==='en'?'What did you buy?':lang==='sv'?'Vad köpte du?':lang==='da'?'Hvad købte du?':'Hva kjøpte du?'}
                style={{ flex:2, fontSize:13, borderRadius:'var(--r-md)', border:'1px solid var(--border)', padding:'8px 12px', background:'var(--surface)', color:'var(--ink)' }}
                onKeyDown={e=>e.key==='Enter'&&addTx()}/>
              <input type="number" value={amount} onChange={e=>setAmount(e.target.value)}
                placeholder="0"
                style={{ flex:1, fontSize:15, fontWeight:700, borderRadius:'var(--r-md)', border:'1px solid var(--border)', padding:'8px 12px', background:'var(--surface)', color:'var(--ink)' }}
                onKeyDown={e=>e.key==='Enter'&&addTx()}/>
            </div>
            <button onClick={addTx} style={{
              width:'100%', padding:'12px', background:'var(--g400)', color:'var(--ink)',
              border:'none', borderRadius:'var(--r-lg)', fontFamily:'var(--font-display)',
              fontSize:14, fontWeight:800, cursor:'pointer',
              boxShadow:'0 4px 12px rgba(34,201,122,0.3)',
            }}>
              {lang==='en'?'Add transaction ✓':lang==='sv'?'Lägg till transaktion ✓':lang==='da'?'Tilføj transaktion ✓':'Legg til transaksjon ✓'}
            </button>
          </div>

          {/* Transaction list */}
          <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
            {filteredTx.length === 0 ? (
              <div style={{ textAlign:'center', padding:'2rem', color:'var(--ink3)', fontSize:13 }}>
                {lang==='en'?'No transactions yet':lang==='sv'?'Inga transaktioner ännu':lang==='da'?'Ingen transaktioner endnu':'Ingen transaksjoner ennå'}
              </div>
            ) : filteredTx.map(tx => {
              const meta = CAT_META[tx.cat] || { icon:'💸', color:'#888', bg:'var(--surface)' };
              const isLockedFixed = tx.locked === true;
              const isSaving = tx.cat === 'Sparing' || (tx.amount > 0 && !isLockedFixed);
              return (
                <div key={tx.id} style={{
                  background: isLockedFixed ? 'var(--r50)' : 'var(--card)',
                  border: `1px solid ${isLockedFixed ? 'var(--r100)' : 'var(--border)'}`,
                  borderRadius:'var(--r-md)', padding:'7px 10px',
                  display:'flex', alignItems:'center', gap:8,
                }}>
                  <div style={{ width:30, height:30, borderRadius:'var(--r-md)', background: isSaving ? '#F5F3FF' : isLockedFixed ? 'var(--r100)' : meta.bg, display:'flex', alignItems:'center', justifyContent:'center', fontSize:18, flexShrink:0 }}>
                    {isSaving ? '🪙' : isLockedFixed ? '🔒' : meta.icon}
                  </div>
                  <div style={{ flex:1, minWidth:0 }}>
                    <div style={{ fontSize:13, fontWeight:600, color:'var(--ink)', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
                      {tx.desc === 'fixed_expenses_key' ? (lang==='en'?'Fixed expenses':lang==='sv'?'Fasta utgifter':lang==='da'?'Faste udgifter':'Faste utgifter') : (tx.desc || '')}
                    </div>
                    <div style={{ fontSize:11, color:'var(--ink3)' }}>{(tx.cat === 'Annet' ? (lang==='en'?'Other':lang==='sv'?'Annat':lang==='da'?'Andet':'Annet') : tx.cat)}{tx.locked ? '' : ' · ' + tx.date}</div>
                  </div>
                  <div style={{ textAlign:'right', flexShrink:0 }}>
                    <div style={{ fontSize:14, fontWeight:700, color: isLockedFixed ? 'var(--r400)' : isSaving ? '#7C3AED' : 'var(--r400)' }}>
                      {isLockedFixed ? `-${fmt(Math.abs(tx.amount), lang)}` : isSaving ? `+${fmt(Math.abs(tx.amount), lang)}` : `-${fmt(Math.abs(tx.amount), lang)}`}
                    </div>
                    {!isLockedFixed && (
                      <button onClick={() => { dispatch({ type:'DELETE_TRANSACTION', payload:tx.id }); if(syncTransaction) syncTransaction(tx.id,'delete'); }}
                        style={{ fontSize:10, color:'var(--ink4)', background:'none', border:'none', cursor:'pointer', padding:0 }}>
                        {lang==='en'?'Delete':lang==='sv'?'Radera':lang==='da'?'Slet':'Slett'}
                      </button>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {budTab === 'subs' && (
        <div>
          <div style={{ background:'var(--card)', border:'1.5px solid var(--border)', borderRadius:'var(--r-lg)', padding:'1rem', marginBottom:12 }}>
            <div style={{ fontSize:12, fontWeight:700, color:'var(--ink3)', marginBottom:10, textTransform:'uppercase', letterSpacing:1 }}>
              + {lang==='en'?'Add subscription':lang==='sv'?'Lägg till prenumeration':lang==='da'?'Tilføj abonnement':'Legg til abonnement'}
            </div>
            <div style={{ display:'flex', gap:6, flexWrap:'wrap', marginBottom:10 }}>
              {[
                {n:'Netflix', logo:'🎬'},{n:'Spotify', logo:'🎵'},{n:'Disney+', logo:'🏰'},
                {n:'HBO', logo:'📺'},{n:'Apple TV', logo:'🍎'},{n:'YouTube', logo:'▶️'},
                {n:'NRK', logo:'📻'},{n:'Viaplay', logo:'🎯'},
              ].map(({n:s, logo}) => (
                <button key={s} onClick={() => setNewSubName(s)} style={{
                  padding:'5px 10px', borderRadius:'var(--r-full)', fontSize:11, fontWeight:600,
                  border: newSubName===s ? '2px solid var(--g400)' : '1px solid var(--border)',
                  background: newSubName===s ? 'var(--g50)' : 'var(--surface)',
                  color: newSubName===s ? 'var(--g600)' : 'var(--ink3)', cursor:'pointer',
                }}>{logo} {s}</button>
              ))}
            </div>
            <div style={{ display:'flex', gap:8, marginBottom:8 }}>
              <input type="text" value={newSubName} onChange={e=>setNewSubName(e.target.value)}
                placeholder={lang==='en'?'e.g. Netflix':lang==='sv'?'t.ex. Netflix':lang==='da'?'f.eks. Netflix':'f.eks. Netflix'}
                style={{ flex:2, fontSize:13, borderRadius:'var(--r-md)', border:'1px solid var(--border)', padding:'8px 12px', background:'var(--surface)', color:'var(--ink)' }}/>
              <input type="number" value={newSubAmt} onChange={e=>setNewSubAmt(e.target.value)}
                placeholder={lang==='en'?'e.g. $99':lang==='sv'?'t.ex. 99 kr':lang==='da'?'f.eks. 99 kr':'f.eks. 99 kr'} style={{ flex:1, fontSize:14, borderRadius:'var(--r-md)', border:'1px solid var(--border)', padding:'8px 12px', background:'var(--surface)', color:'var(--ink)' }}/>
            </div>
            <button onClick={addSub} style={{ width:'100%', padding:'9px', background:'var(--g400)', color:'var(--ink)', border:'none', borderRadius:'var(--r-md)', fontFamily:'var(--font-display)', fontSize:13, fontWeight:700, cursor:'pointer' }}>
              {lang==='en'?'Add subscription':lang==='sv'?'Lägg till prenumeration':lang==='da'?'Tilføj abonnement':'Legg til abonnement'} ✓
            </button>
          </div>
          {(state.subscriptions||[]).length === 0 ? (
            <div style={{ textAlign:'center', padding:'2rem', color:'var(--ink3)', fontSize:13 }}>
              {lang==='en'?'No subscriptions yet':lang==='sv'?'Inga prenumerationer':lang==='da'?'Ingen abonnementer':'Ingen abonnementer ennå'}
            </div>
          ) : (state.subscriptions||[]).map(sub => (
            <div key={sub.id} style={{ background:'var(--card)', border:'1px solid var(--border)', borderRadius:'var(--r-lg)', padding:'10px 14px', display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:8 }}>
              <div>
                <div style={{ fontSize:13, fontWeight:600 }}>📱 {sub.name}</div>
                <div style={{ fontSize:11, color:'var(--ink3)' }}>{lang==='en'?'Monthly':lang==='sv'?'Månadsvis':lang==='da'?'Månedligt':'Månedlig'}</div>
              </div>
              <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                <div style={{ fontSize:14, fontWeight:700, color:'var(--r400)' }}>-{fmt(sub.amount, lang)}</div>
                <button onClick={() => dispatch({ type:'DELETE_SUBSCRIPTION', payload:sub.id })} style={{ fontSize:12, background:'none', border:'none', cursor:'pointer', color:'var(--ink4)' }}>✕</button>
              </div>
            </div>
          ))}
        </div>
      )}

      <div style={{ height:16 }}/>
    </div>
  );
}
